import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Gallery from "@/pages/Gallery";
import AlbumDetail from "@/pages/AlbumDetail";
import Industries from "@/pages/Industries";
import Process from "@/pages/Process";
import Capabilities from "@/pages/Capabilities";
import FAQ from "@/pages/FAQ";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Blog from "@/pages/Blog";
import AdminLogin from "@/pages/AdminLogin";
import AdminGallery from "@/pages/AdminGallery";
import AdminInbox from "@/pages/AdminInbox";
import AdminReviews from "@/pages/AdminReviews";
import { Toaster } from "sonner";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:slug" element={<AlbumDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/process" element={<Process />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/request-a-quote" element={<Quote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Privacy />} />
          <Route path="/sitemap" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/quotes" element={<AdminInbox />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster theme="dark" position="top-right" richColors />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
